import React from 'react';

import CoreUtils from '../../../common/utils/CoreUtils';
import StringUtils from '../../../common/utils/StringUtils';

import ConfigurationApi from '../../../api-services/ConfigurationApi';

import PreferenceManager from '../../../application/PreferenceManager';

import DataItemView from '../../../common/view/DataItemView';
import ModifiedFlag from '../../../common/controls/ModifiedFlag';
import ErrorFlag from '../../../common/controls/ErrorFlag';
import TileView from '../../../common/controls/TileView';

import CounterpartyLogo from '../models/CounterpartyLogo';
import ContractList from '../models/ContractList';

import CounterpartyLogoView from './CounterpartyLogoView';
import ContractTile from './ContractTile';
import ContractView from './ContractView';
import ParametersView from './ParametersView';
import TableauPageListView from './TableauPageListView';

import BooleanEditor from '../../../common/metadata/BooleanEditor';
import NumberEditor from '../../../common/metadata/NumberEditor';
import SelectEditor from '../../../common/metadata/SelectEditor';
import StringEditor from '../../../common/metadata/StringEditor';
import TimeSpanEditor from '../../../common/metadata/TimeSpanEditor';
import QuickEntryConfigurationEditor from '../../../common/metadata/QuickEntryConfigurationEditor';

export default class CounterpartyView extends DataItemView {
  static displayName = CounterpartyView.name;

  constructor(props) {
    super(props);

    this.onEditorValueListener = this.onEditorValueChanged.bind(this);
    this.bindDataItem(props.counterparty);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.counterparty);
  }

  dataItemDidBind(dataItem) {
    this.loadGroupProperties(dataItem);
  }

  dataItemWillUnbind(dataItem) {
    this.setState({
      selectedContract: null
    });
  }

  render() {
    if (!this.state.isDataBound)
      return (
        <div>
          <table><tbody><tr>
            <td valign="top">
              <div className="pwx-counterparty-view-container" />
            </td>
          </tr></tbody></table>
        </div>
      );

    return (
      <table><tbody><tr>
        <td valign="top">
          <div className={this.getCounterpartyViewClassNames(this.state.isDeleted)}>
            <div className="pwx-view-header">
              <span className="pwx-view-title">{this.resolveViewTitle(this.state.code, this.state.displayName)}</span>
              <span>&nbsp;</span>
              <span className="pwx-modified-flag dx-icon-rename" hidden={!this.state.isModified} />
              <span className="pwx-error-flag dx-icon-warning" hidden={!this.state.hasErrors} />
              <span className="pwx-update-flag dx-icon-clear" hidden={!StringUtils.isNonEmptyString(this.state.updateErrorMessage)} title={this.state.updateErrorMessage} />
            </div>
            <div className="pwx-counterparty-view-content">
              <CounterpartyLogoView
                counterpartyLogo={this.state.counterpartyLogo}
                counterpartyLabel={this.state.shortName}
                imageMimeTypes={this.props.imageMimeTypes}
              />
              <table><tbody>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Code:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <StringEditor name="code" value={this.state.code} onValueChanged={this.onEditorValueListener} />
                    <ModifiedFlag isModifiedProperty={this.state.code_isModified} />
                    <ErrorFlag errorProperty={this.state.code_error} />
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Short Name:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <StringEditor name="shortName" value={this.state.shortName} onValueChanged={this.onEditorValueListener} />
                    <ModifiedFlag isModifiedProperty={this.state.shortName_isModified} />
                    <ErrorFlag errorProperty={this.state.shortName_error} />
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Display Name:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <StringEditor name="displayName" value={this.state.displayName} onValueChanged={this.onEditorValueListener} />
                    <ModifiedFlag isModifiedProperty={this.state.displayName_isModified} />
                    <ErrorFlag errorProperty={this.state.displayName_error} />
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Is Active:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <BooleanEditor name="isActive" value={this.state.isActive} onValueChanged={this.onEditorValueListener} />
                    <ModifiedFlag isModifiedProperty={this.state.isActive_isModified} />
                    <ErrorFlag errorProperty={this.state.isActive_error} />
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Viewer Role:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody>
                      <tr>
                        <td className="pwx-select-box">
                          <SelectEditor
                            options={this.state.counterpartyViewerRole_options}
                            displayExpr="displayValue"
                            height="28px"
                            name="counterpartyViewerRole"
                            showClearButton={false}
                            value={this.state.counterpartyViewerRole}
                            onValueChanged={this.onEditorValueListener}
                            width="180px"
                          />
                        </td>
                        <td>
                          <ModifiedFlag isModifiedProperty={this.state.counterpartyViewerRole_isModified} />
                          <ErrorFlag errorProperty={this.state.counterpartyViewerRole_error} />
                        </td>
                      </tr>
                    </tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Editor Role:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody>
                      <tr>
                        <td className="pwx-select-box">
                          <SelectEditor
                            options={this.state.counterpartyEditorRole_options}
                            displayExpr="displayValue"
                            height="28px"
                            name="counterpartyEditorRole"
                            showClearButton={false}
                            value={this.state.counterpartyEditorRole}
                            onValueChanged={this.onEditorValueListener}
                            width="180px"
                          />
                        </td>
                        <td>
                          <ModifiedFlag isModifiedProperty={this.state.counterpartyEditorRole_isModified} />
                          <ErrorFlag errorProperty={this.state.counterpartyEditorRole_error} />
                        </td>
                      </tr>
                    </tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Template:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody>
                      <tr>
                        <td className="pwx-select-box">
                          <SelectEditor
                            options={this.state.templateName_options}
                            displayExpr="displayValue"
                            disabled={!this.state.isNew}
                            height="28px"
                            name="templateName"
                            showClearButton={false}
                            value={this.state.templateName}
                            onValueChanged={this.onEditorValueListener}
                            width="180px"
                          />
                        </td>
                        <td>
                          <ModifiedFlag isModifiedProperty={this.state.templateName_isModified} />
                          <ErrorFlag errorProperty={this.state.templateName_error} />
                        </td>
                      </tr>
                    </tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Show Zero Values:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <BooleanEditor name="showZeroValues" value={this.state.showZeroValues} onValueChanged={this.onEditorValueListener} />
                    <ModifiedFlag isModifiedProperty={this.state.showZeroValues_isModified} />
                    <ErrorFlag errorProperty={this.state.showZeroValues_error} />
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">First Day Of Week:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody>
                      <tr>
                        <td className="pwx-select-box">
                          <SelectEditor
                            options={this.state.firstDayOfWeek_options}
                            displayExpr="displayValue"
                            height="28px"
                            name="firstDayOfWeek"
                            showClearButton={false}
                            value={this.state.firstDayOfWeek}
                            onValueChanged={this.onEditorValueListener}
                            width="130px"
                          />
                        </td>
                        <td>
                          <ModifiedFlag isModifiedProperty={this.state.firstDayOfWeek_isModified} />
                          <ErrorFlag errorProperty={this.state.firstDayOfWeek_error} />
                        </td>
                      </tr>
                    </tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Heavy-Light Hour Scheme:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody>
                      <tr>
                        <td className="pwx-select-box">
                          <SelectEditor
                            options={this.state.heavyLightHourScheme_options}
                            displayExpr="displayValue"
                            height="28px"
                            name="heavyLightHourScheme"
                            showClearButton={false}
                            value={this.state.heavyLightHourScheme}
                            onValueChanged={this.onEditorValueListener}
                            width="180px"
                          />
                        </td>
                        <td>
                          <ModifiedFlag isModifiedProperty={this.state.heavyLightHourScheme_isModified} />
                          <ErrorFlag errorProperty={this.state.heavyLightHourScheme_error} />
                        </td>
                      </tr>
                    </tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Quick Entry Fields:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody><tr>
                      <td>
                        <QuickEntryConfigurationEditor name="quickEntryConfiguration" value={this.state.quickEntryConfiguration} onValueChanged={this.onEditorValueListener} />
                      </td>
                      <td>
                        <ModifiedFlag isModifiedProperty={this.state.quickEntryConfiguration_isModified} />
                        <ErrorFlag errorProperty={this.state.quickEntryConfiguration_error} />
                      </td>
                    </tr></tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Quick Entry Labels:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody>
                      <tr>
                        <td className="pwx-select-box">
                          <SelectEditor
                            options={this.state.quickEntryLabels_options}
                            displayExpr="displayValue"
                            height="28px"
                            name="quickEntryLabels"
                            showClearButton={false}
                            value={this.state.quickEntryLabels}
                            onValueChanged={this.onEditorValueListener}
                            width="135px"
                          />
                        </td>
                        <td>
                          <ModifiedFlag isModifiedProperty={this.state.quickEntryLabels_isModified} />
                          <ErrorFlag errorProperty={this.state.quickEntryLabels_error} />
                        </td>
                      </tr>
                    </tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Highlight HLH/LLH Fields:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <BooleanEditor name="highlightHlhLlhFields" value={this.state.highlightHlhLlhFields} onValueChanged={this.onEditorValueListener} />
                    <ModifiedFlag isModifiedProperty={this.state.highlightHlhLlhFields_isModified} />
                    <ErrorFlag errorProperty={this.state.highlightHlhLlhFields_error} />
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Preschedule Rollover T-Minus:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody><tr>
                      <td>
                        <TimeSpanEditor
                          name="prescheduleDateRolloverPeriod"
                          value={this.state.prescheduleDateRolloverPeriod}
                          onValueChanged={this.onEditorValueListener}
                          width="75px"
                        />
                      </td>
                      <td>
                        &nbsp;(H:MM:SS)
                        <ModifiedFlag isModifiedProperty={this.state.prescheduleDateRolloverPeriod_isModified} />
                        <ErrorFlag errorProperty={this.state.prescheduleDateRolloverPeriod_error} />
                      </td>
                    </tr></tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Preschedule Rollover Warning:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <NumberEditor name="prescheduleDateRolloverWarning" value={this.state.prescheduleDateRolloverWarning} onValueChanged={this.onEditorValueListener} />
                    &nbsp;second(s)
                    <ModifiedFlag isModifiedProperty={this.state.prescheduleDateRolloverWarning_isModified} />
                    <ErrorFlag errorProperty={this.state.prescheduleDateRolloverWarning_error} />
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Realtime Rollover T-Minus:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <table><tbody><tr>
                      <td>
                        <TimeSpanEditor
                          name="realtimeDateRolloverPeriod"
                          value={this.state.realtimeDateRolloverPeriod}
                          onValueChanged={this.onEditorValueListener}
                          width="75px"
                        />
                      </td>
                      <td>
                        &nbsp;(H:MM:SS)
                        <ModifiedFlag isModifiedProperty={this.state.realtimeDateRolloverPeriod_isModified} />
                        <ErrorFlag errorProperty={this.state.realtimeDateRolloverPeriod_error} />
                      </td>
                    </tr></tbody></table>
                  </td>
                </tr>
                <tr className="pwx-field">
                  <td className="pwx-field-label">Realtime Rollover Warning:</td>
                  <td className="pwx-field-spacer" />
                  <td className="pwx-field-value">
                    <NumberEditor name="realtimeDateRolloverWarning" value={this.state.realtimeDateRolloverWarning} onValueChanged={this.onEditorValueListener} />
                    &nbsp;second(s)
                    <ModifiedFlag isModifiedProperty={this.state.realtimeDateRolloverWarning_isModified} />
                    <ErrorFlag errorProperty={this.state.realtimeDateRolloverWarning_error} />
                  </td>
                </tr>
              </tbody></table>

              <ParametersView parameters={this.state.parameters} />

              <div className="pwx-tableau-section-view">
                <div className="pwx-tableau-section-title">TABLEAU PAGES</div>
                  <div className="pwx-tableau-section-general-properties">
                    <table><tbody>
                      <tr className="pwx-field">
                        <td className="pwx-field-label">Section Title:</td>
                        <td className="pwx-field-spacer" />
                        <td className="pwx-field-value" colSpan="6">
                          <StringEditor name="tableauSectionTitle" value={this.state.tableauSectionTitle} onValueChanged={this.onEditorValueListener} />
                          <ModifiedFlag isModifiedProperty={this.state.tableauSectionTitle_isModified} />
                          <ErrorFlag errorProperty={this.state.tableauSectionTitle_error} />
                        </td>
                      </tr>
                      <tr className="pwx-field">
                        <td className="pwx-field-label">Is Visible:</td>
                        <td className="pwx-field-spacer" />
                        <td className="pwx-field-value" width="50px">
                          <BooleanEditor name="tableauIsVisible" value={this.state.tableauIsVisible} onValueChanged={this.onEditorValueListener} />
                          <ModifiedFlag isModifiedProperty={this.state.tableauIsVisible_isModified} />
                          <ErrorFlag errorProperty={this.state.tableauIsVisible_error} />
                        </td>
                        <td className="pwx-field-spacer" width="70px"/>
                        <td className="pwx-field-label" width="85px">Is Enabled:</td>
                        <td className="pwx-field-spacer" />
                        <td className="pwx-field-value">
                          <BooleanEditor name="tableauIsEnabled" value={this.state.tableauIsEnabled} onValueChanged={this.onEditorValueListener} />
                          <ModifiedFlag isModifiedProperty={this.state.tableauIsEnabled_isModified} />
                          <ErrorFlag errorProperty={this.state.tableauIsEnabled_error} />
                        </td>
                        <td width="auto" />
                      </tr>
                      <tr className="pwx-field">
                        <td className="pwx-field-label">Script URL:</td>
                        <td className="pwx-field-spacer" />
                        <td className="pwx-field-value" colSpan="6">
                          <StringEditor name="tableauScriptUrl" size="40" value={this.state.tableauScriptUrl} onValueChanged={this.onEditorValueListener} />
                          <ModifiedFlag isModifiedProperty={this.state.tableauScriptUrl_isModified} />
                          <ErrorFlag errorProperty={this.state.tableauScriptUrl_error} />
                        </td>
                      </tr>
                      <tr className="pwx-field">
                        <td className="pwx-field-label">Auth Token:</td>
                        <td className="pwx-field-spacer" />
                        <td className="pwx-field-value" colSpan="6">
                          <table><tbody>
                            <tr>
                              <td className="pwx-select-box">
                                <SelectEditor
                                  options={this.state.tableauTokenGuid_options}
                                  displayExpr="displayValue"
                                  height="28px"
                                  name="tableauTokenGuid"
                                  showClearButton={false}
                                  value={this.state.tableauTokenGuid}
                                  onValueChanged={this.onEditorValueListener}
                                  width="190px"
                                />
                              </td>
                              <td>
                                <ModifiedFlag isModifiedProperty={this.state.tableauTokenGuid_isModified} />
                                <ErrorFlag errorProperty={this.state.tableauTokenGuid_error} />
                              </td>
                            </tr>
                          </tbody></table>
                        </td>
                      </tr>
                    </tbody></table>
                </div>

                <div>
                  <TableauPageListView tableauPageList={this.state.tableauPages} />
                </div>

              </div>
            </div>
          </div>
        </td>
        <td className="pwx-contract-list" valign="top">
          <TileView
            keyExpr="key"
            itemsSource={this.state.contracts}
            onSelectionChanged={this.onContractSelectionChanged.bind(this)}
            renderTile={contract => (<ContractTile key={contract.key} contract={contract} />)}
            selectedItem={this.state.selectedContract}
            tileStyle="pwx-tile-border"
            title="CONTRACTS"
            selectedTileStyle="pwx-tile-border-selected"
            sortField="code"
            spacerStyle="pwx-tile-spacer"
          />
        </td>
        <td valign="top">
          <ContractView contract={this.state.selectedContract} />
        </td>
      </tr>
      </tbody>
      </table>
    );
  }

  getCounterpartyViewClassNames(isDeleted) {
    var classNames = 'pwx-counterparty-view-container pwx-counterparty-view';
    if (isDeleted)
      classNames += ' pwx-item-deleted';

    return classNames;
  }

  resolveViewTitle(code, displayName) {
    var useCode = StringUtils.isNonEmptyString(code);
    var useDisplayName = StringUtils.isNonEmptyString(displayName);

    if (useCode && useDisplayName)
      return `${displayName} (${code})`;

    if (useCode)
      return code;

    if (useDisplayName)
      return displayName;

    return 'Counterparty Details';
  }

  async loadGroupProperties(dataItem) {
    if (CoreUtils.isUndefinedOrNull(dataItem.counterpartyLogo) || CoreUtils.isUndefinedOrNull(dataItem.contracts)) {
      var metadataRulesDto = await ConfigurationApi.getMetadataRules();

      var counterpartyLogo = new CounterpartyLogo(metadataRulesDto);
      var contracts = new ContractList(metadataRulesDto);

      if (!dataItem.isNew) {
        var counterpartyLogoDto = await ConfigurationApi.getCounterpartyLogo(dataItem.guid);
        var contractDtos = await ConfigurationApi.getContracts(dataItem.guid);

        counterpartyLogo.initDataObject(counterpartyLogoDto);
        contracts.initDataObjects(contractDtos, metadataRulesDto);
      } else
        counterpartyLogo.createDataObject();

      dataItem.attachGroupProperty('counterpartyLogo', counterpartyLogo);
      dataItem.attachGroupProperty('contracts', contracts);
    }

    this.selectDefaultContract();
  }

  selectDefaultContract() {
    var lastActiveContractCode = PreferenceManager.retrieveValue(
      PreferenceManager.Configuration,
      this.getSelectedContractPreferenceName(this.dataItem),
      null
    );

    var selectedContract = null;
    if (CoreUtils.isDefinedAndNotNull(lastActiveContractCode)) {
      selectedContract = this.dataItem.contracts.find(contract => contract.code === lastActiveContractCode);
    }

    if (CoreUtils.isUndefinedOrNull(selectedContract) && this.dataItem.contracts.length > 0)
      selectedContract = this.dataItem.contracts.getAt(0);

    if (this.isViewMounted)
      this.setState({
        selectedContract: selectedContract
      });
    else
      this.state.selectedContract = selectedContract;
  }

  onContractSelectionChanged(item) {
    this.setState({
      selectedContract: item,
    });

    if (CoreUtils.isDefinedAndNotNull(item))
      PreferenceManager.updateValue(
        PreferenceManager.Configuration,
        this.getSelectedContractPreferenceName(this.dataItem),
        item.code
      );
  }

  getSelectedContractPreferenceName(counterparty) {
    return `${PreferenceManager.SelectedContract}_${counterparty.code}`;
  }

  onEditorValueChanged(propertyName, value) {
    if (this.dataItem !== null)
      this.dataItem.updateProperty(propertyName, value);
  }
}